import Smelting from './Smelting.png';
import Woodworking from './Woodworking.png';
import Leatherworking from './Leatherworking.png';
import Weaving from './Weaving.png';
import Stonecutting from './Stonecutting.png';

import type { RefiningSkill } from '#types/skills';

export const RefiningImgs: Record<RefiningSkill, string> = {
  Smelting,
  Woodworking,
  Leatherworking,
  Weaving,
  Stonecutting,
};
export default RefiningImgs;
